<template>
  <b-modal id="modal-dialog" ref="modal-dialog" size="xl" :title="title" @hidden="clearModalData">
    <!-- device picker modal -->
    <DevicesViewer v-if="show" :picker-mode="true" :filter-array="selectedDevices" @item-clicked="addDevice"
      @deselect-all="deselectAll" />
    <!-- modal buttons -->
    <div slot="modal-footer" class="w-100">
      <b-button variant="primary" v-if="confirmText" class="float-right mx-2" @click="modalConfirm">{{ confirmText
      }}</b-button>
      <b-button variant="light" v-if="cancelText" class="float-right mx-2" @click="modalCancel">{{ cancelText
      }}</b-button>
    </div>
  </b-modal>
</template>

<script>
import DevicesViewer from '@/components/DevicesViewer.vue';
import mediaMixin from '@/views/admin/media/mediaMixin';

export default {
  mixins: [mediaMixin],
  components: {
    DevicesViewer,
  },
  data() {
    return {
      show: false,
      title: 'Choose devices',
      cbConfirm: null,
      confirmText: 'OK',
      cancelText: 'Cancel',
      devicesArray: [],
      devicesFilterArray: [],
    };
  },
  created() {
    this.$root.$on('modal-show-device-picker', this.showModal);
  },
  beforeDestroy() {
    this.$root.$off('modal-show-device-picker', this.showModal);
  },
  methods: {
    showModal({
      cbConfirm,
      devicesFilterArray,
    }) {
      this.show = true;
      this.devicesFilterArray = devicesFilterArray ? devicesFilterArray.map(e => ({ ...e, unavailable: true })) : [];
      this.cbConfirm = cbConfirm || null;
      this.$refs['modal-dialog'].show();
    },
    hideModal() {
      this.$refs['modal-dialog'].hide();
    },
    clearModalData() {
      this.show = false;
      this.title = 'Choose devices';
      this.cbConfirm = null;
      this.confirmText = 'OK';
      this.cancelText = 'Cancel';
      this.devicesFilterArray = [];
      this.devicesArray = [];
    },
    modalConfirm() {
      if (this.cbConfirm) {
        this.cbConfirm(this.devicesArray);
      }
      this.hideModal();
    },
    modalCancel() {
      if (this.cbCancel) this.cbCancel();
      this.hideModal();
    },
    addDevice(d, isAll) {
      const foundInFilter = this.devicesFilterArray.find(e => e.id === d.id);
      const foundInExisting = this.devicesArray.find(e => e.id === d.id);
      if (!foundInFilter && !foundInExisting) {
        this.devicesArray.push(d);
      } else if (foundInFilter) {
        if (!isAll) {
          this.$root.$emit('notification-add', { content: 'Device already selected.', variant: 'danger' });
        }
      } else if (foundInExisting) {
        this.devicesArray = this.devicesArray.filter(e => e !== foundInExisting);
      }
    },
    deselectAll() {
      this.devicesArray = [];
    },
  },
  computed: {
    selectedDevices() {
      return [...this.devicesArray, ...this.devicesFilterArray];
    },
  },
};
</script>
